import React from 'react';
export function TrustBar() {
  return <section className="w-full bg-bg-alt py-5 border-y border-border-light px-4 relative overflow-hidden" data-id="element-238">
      {/* Subtle gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-primary/5 to-transparent" data-id="element-239"></div>

      <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-4 text-center relative z-10" data-id="element-240">
        <div className="flex items-center gap-2 text-2xl bg-white/5 px-4 py-2 rounded-full border border-white/10 shadow-inner" data-id="element-241">
          <span data-id="element-242">🇲🇽</span>
          <span data-id="element-243">🇪🇸</span>
          <span data-id="element-244">🇦🇷</span>
          <span data-id="element-245">🇨🇱</span>
          <span data-id="element-246">🇨🇴</span>
        </div>
        <p className="text-text-sec text-sm sm:text-base font-medium" data-id="element-247">
          Utilizado por más de{' '}
          <span className="font-bold text-primary drop-shadow-[0_0_8px_rgba(132,204,22,0.5)]" data-id="element-248">
            12,000 profesionales y estudiantes
          </span>{' '}
          en toda Latinoamérica y España.
        </p>
      </div>
    </section>;
}